import { FC, useState } from 'react';
import styled from 'styled-components';

import { useTasks } from '@/features/vfo/hooks/useTasks';
import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { Button } from '@/shared/uikitV2/Button';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { DeleteTaskModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../../interwill/containers/ModalContainerV2';

export const DeleteTaskModal: FC<DeleteTaskModalProps> = ({ taskId, onDelete }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'deleteTask' });
  const modals = useModalsStore();
  const { deleteTask } = useTasks();

  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    setIsLoading(true);
    const isDeleted = await deleteTask(taskId);
    setIsLoading(false);

    if (isDeleted) {
      modals.closeModal();
      onDelete?.();
    }
  };

  return (
    <ModalContainerV2 pinBottom title={t('title')} closable>
      <ModalBody>
        <p>{t.rich('description')}</p>
      </ModalBody>
      <Buttons>
        <Button type="default" size="middle" onClick={modals.closeModal}>
          {t('btnCancel')}
        </Button>
        <ButtonDelete type="primary" size="middle" onClick={handleDelete} loading={isLoading}>
          {t('btnDelete')}
        </ButtonDelete>
      </Buttons>
    </ModalContainerV2>
  );
};

const ModalBody = styled.div`
  font-size: 14px;
  line-height: 20px;
  padding-block: 16px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 16px;

  ${media.sm} {
    margin-top: 16px;
    flex-direction: column;
    align-items: stretch;
  }
`;

const ButtonDelete = styled(Button)`
  &&& {
    background: ${COLORS.systemFlame200} !important;

    &:hover {
      background: ${COLORS.systemFlame300} !important;
    }
  }
`;
